export enum scoutsCompanyTypes {
  FETCH_SCOUTS_COMPANY_REQUEST = "FETCH_SCOUTS_COMPANY_REQUEST",
  FETCH_SCOUTS_COMPANY_SUCCESS = "FETCH_SCOUTS_COMPANY_SUCCESS",
  FETCH_SCOUTS_COMPANY_FAILURE = "FETCH_SCOUTS_COMPANY_FAILURE",
}